import useAuthActiveSubscriptionTiers from '@apps/www/src/www/hooks/useAuthActiveSubscriptionTiers';
import config from '@pkgs/shared-client/config';
import SubscriptionTier from '@pkgs/shared/enums/SubscriptionTier';
import subscriptionTiersHasSubscriptionTierPrivileges from '@pkgs/shared/helpers/subscriptionTiersHasSubscriptionTierPrivileges';

export default function useItemsLimit(): number {
	const subscriptionTiers = useAuthActiveSubscriptionTiers();

	if (subscriptionTiersHasSubscriptionTierPrivileges(subscriptionTiers, SubscriptionTier.PRO)) {
		return config.payment.maxPaidItems;
	}

	if (
		subscriptionTiersHasSubscriptionTierPrivileges(subscriptionTiers, SubscriptionTier.STARTER)
	) {
		return config.payment.maxStarterItems;
	}

	return config.payment.maxFreeItems;
}
